import { CreateRequestModal } from './CreateRequestModal';
import withFlaggedTransactions from './withFlaggedTransactions';
import withQueue from './withQueue';

export const FlaggedTransactionCreateAskReq = withFlaggedTransactions(CreateRequestModal);
export const QueueCreateAskReq = withQueue(CreateRequestModal);
